<template>
  <div>
    <div
      style="
        border-bottom: 1px solid rgba(155, 155, 155, 0.25);
        margin-bottom: 20px;
      "
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="填报单位" style="margin-right: 30px">
          <el-input v-model="formInline.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <el-select clearable v-model="formInline.region" placeholder="请选择">
            <el-option
              :key="item.code"
              :label="item.name"
              :value="item.code"
              v-for="item in seatList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报表">
          <el-select
            clearable
            v-model="formInline.report_cycle"
            placeholder="请选择"
          >
            <el-option label="重点监测企业产值表" value="001"></el-option>
            <el-option label="重点监测企业财务表" value="002"></el-option>
            <el-option label="工业园区基本情况表" value="003"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="填报期">
          <el-date-picker
            clearable
            format="yyyy-MM"
            value-format="yyyy-MM"
            v-model="formInline.date_range"
            type="month"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否规上企业">
          <el-select
            clearable
            v-model="formInline.above_scale"
            placeholder="请选择"
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-bottom: 24px">
      <el-button type="primary" @click="toPass(selectRow)" class="bg5584FF"
        >批量通过</el-button
      >
    </div>
    <el-link style="margin-bottom: 20px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <el-table
      border
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="company_name" label="填报单位" align="center">
      </el-table-column>
      <el-table-column prop="name" label="填报名" align="center">
        <template slot-scope="scope">
          <span class="detail" @click="toDetail(scope.row)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date_range" label="填报期" align="center">
        <template slot-scope="scope">
          <span>{{ getDateRange(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date_range" label="填报开始时间" align="center">
      </el-table-column>
      <el-table-column
        prop="date_range_end"
        label="填报结束时间"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="crt_time" label="上报时间" align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class="dialog770 titleChange"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="toApprove([scope.row.id], scope.row)"
            >审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <!-- <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[20, 30, 50, 100]"
        layout="sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination> -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="20"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      append-to-body
      title="审核不通过"
      :visible.sync="notPassDialogVisible"
      :close-on-click-modal="false"
      class="titleChange"
      width="770px"
    >
      <el-form
        :model="notPassForm"
        :rules="rules"
        ref="notPassForm"
        label-width="135px"
        class="demo-RuleForm"
        size="small"
        v-loading="notPassLoading"
      >
        <el-form-item label="意见：" prop="reason">
          <el-input
            v-model="notPassForm.reason"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btnBox">
        <el-button type="primary" @click="sureNotPass()">确定</el-button>
        <el-button @click="notPassDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      append-to-body
      title="审核弹窗"
      :visible.sync="apporveDialogVisible"
      :close-on-click-modal="false"
      class="titleChange"
      width="1160px"
    >
      <div>
        <el-button type="primary" @click="surePass()" class="bg5584FF"
          >审核通过</el-button
        >
        <el-button
          type="primary"
          @click="toNotPass()"
          style="background-color: #a2231f; border-color: #a2231f"
          >审核不通过
        </el-button>
        <el-button @click="apporveDialogVisible = false">退出审核</el-button>
      </div>
      <div
        style="
          margin-top: 48px;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          padding-top: 24px;
        "
      >
        <div
          style="font-size: 24px; font-weight: bold; color: rgba(68, 68, 68, 1)"
        >
          报表详情
        </div>
        <zdquczbShow
          v-if="editCode == '001'"
          :id="sureList[0]"
          :report_yidong="report_yidong"
        ></zdquczbShow>
        <zdjcqycwbShow
          v-if="editCode == '002'"
          :id="sureList[0]"
          :report_yidong="report_yidong"
        ></zdjcqycwbShow>
        <gyyqjbqkbShow
          v-if="editCode == '003'"
          :id="sureList[0]"
          :report_yidong="report_yidong"
        ></gyyqjbqkbShow>
      </div>
    </el-dialog>
    <el-dialog
      v-if="showDialogVisible"
      title="报表详情"
      :visible.sync="showDialogVisible"
      class="dialog770 titleChange"
      width="1160px"
      append-to-body
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <zdquczbShow
        v-if="editCode == '001'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></zdquczbShow>
      <zdjcqycwbShow
        v-if="editCode == '002'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></zdjcqycwbShow>
      <gyyqjbqkbShow
        v-if="editCode == '003'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></gyyqjbqkbShow>
    </el-dialog>
  </div>
</template>

<script>
import zdquczbShow from "./../../../DataCollection/DataWrite/notInsert/zdquczbShow/index";
import zdjcqycwbShow from "./../../../DataCollection/DataWrite/notInsert/zdjcqycwbShow/index";
import gyyqjbqkbShow from "./../../../DataCollection/DataWrite/notInsert/gyyqjbqkbShow/index";
import { mapGetters } from "vuex";
import { export2Excel } from "@/utils/utils";
export default {
  name: "index",
  props: {
    report_cycle: {
      type: String,
      default: "",
    },
    method: {
      type: String,
      default: "",
    },
    region: {
      type: String,
      default: "",
    },
    date_range: {
      type: String,
      default: "",
    },
  },
  components: {
    zdjcqycwbShow,
    gyyqjbqkbShow,
    zdquczbShow,
  },
  data() {
    return {
      report_yidong: 0,
      tableData: [],
      currentPage: 1,
      loading: false,
      formInline: {
        name: "",
        region: "",
        report_cycle: "",
        date_range: "",
        above_scale: "",
      },
      regionTree: [],
      notPassForm: {
        reason: "",
      },
      passForm: {
        reason: "",
      },
      exportLabel: "<<点击此处可导出报表",
      selectRow: [],
      showObj: {},
      zdjcqyczbId: "",
      pageSize: 10,
      notPassDialogVisible: false,
      passDialogVisible: false,
      notPassLoading: false,
      passLoading: false,
      editCode: "",
      total: 0,
      sureList: [],
      rules: {
        //表单验证规则
        reason: [{ required: true, message: "请输入意见", trigger: "blur" }],
      },
      detailDialogVisible: false,
      showDialogVisible: false,
      apporveDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  methods: {
    getDateRange(row) {
      const month = Number(row.date_range.split("-")[1]);
      const year = Number(row.date_range.split("-")[0]);
      if (row.report_cycle == 0) {
        //月报
        return row.date_range;
      } else if (row.report_cycle == 1) {
        //季报
        if (month <= 3) {
          return `${year}年第一季度`;
        } else if (month >= 4 && month <= 6) {
          return `${year}年第二季度`;
        } else if (month >= 7 && month <= 9) {
          return `${year}年第三季度`;
        } else {
          return `${year}年第四季度`;
        }
      } else if (row.report_cycle == 2) {
        //半年报
        if (month <= 6) {
          return `${year}年上半年`;
        } else {
          return `${year}年下半年`;
        }
      } else {
        //年报
        return `${year}年`;
      }
    },
    getdata(page) {
      this.loading = true;
      this.tableData = [];
      const param = {
        page: page || 1,
        pageSize: this.pageSize,
        status: "wsh",
      };
      if (this.formInline.name !== "") {
        param["name"] = this.formInline.name;
      }
      if (this.formInline.region !== "") {
        param["region"] = this.formInline.region;
      }
      if (this.formInline.report_cycle !== "") {
        param["report_cycle"] = this.formInline.report_cycle;
      }
      if (this.formInline.date_range && this.formInline.date_range !== "") {
        param["date_range"] = this.formInline.date_range;
      }
      if (this.formInline.above_scale !== "") {
        param["above_scale"] = this.formInline.above_scale;
      }
      let methods = "/business/insertMonitor/queryHandleList";
      if (this.method === "noRole") {
        methods = "/business/insertMonitor/showCompanyByName";
      }
      this.$axios.post(methods, param).then((res) => {
        res.data.forEach((temp) => {
          if (temp.park_name) {
            temp.company_name = temp.park_name;
            temp.company_phone = temp.park_phone;
          }
          temp.crt_time = this.$moment(temp.crt_time).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          temp.date_range_end = this.$moment(temp.date_range_end)
            .endOf("month")
            .format("YYYY-MM-DD");
        });
        this.tableData = res.data;
        this.total = res.total;
        this.loading = false;
      });
    },
    sureNotPass() {
      this.$refs.notPassForm.validate((valid) => {
        if (valid) {
          const param = {
            type: "N",
            desc: this.notPassForm.reason,
            dataList: this.sureList,
          };
          this.$axios
            .put("/business/insertMonitor/toHandleExamine", param)
            .then((res) => {
              this.$message.success("审批成功");
              this.getdata();
              this.notPassLoading = true;
              this.notPassLoading = false;
              this.apporveDialogVisible = false;
              this.notPassDialogVisible = false;
            });
        }
      });
    },
    surePass() {
      const param = {
        type: "Y",
        dataList: this.sureList,
      };
      this.$axios
        .put("/business/insertMonitor/toHandleExamine", param)
        .then((res) => {
          this.$message.success("审批成功");
          this.getdata();
          this.passLoading = true;
          this.passLoading = false;
          this.apporveDialogVisible = false;
          this.passDialogVisible = false;
        });
    },
    toNotPass(rowList) {
      if (rowList) {
        if (rowList.length) {
          this.sureList = rowList;
          this.notPassForm = {
            reason: "",
          };
          this.notPassDialogVisible = true;
        }
      } else {
        this.notPassForm = {
          reason: "",
        };
        this.notPassDialogVisible = true;
      }
    },
    toPass(rowList) {
      if (rowList) {
        if (rowList.length) {
          this.sureList = rowList;
          this.passForm = {
            reason: "",
          };
          this.$confirm("是否确定批量审核，此操作不可逆", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.surePass();
            })
            .catch(() => {});
        }
      } else {
        this.passForm = {
          reason: "",
        };
        this.passDialogVisible = true;
      }
    },
    toApprove(rowList, row) {
      this.editCode = row.code;
      this.sureList = rowList;
      this.report_yidong = row.report_yidong;
      this.apporveDialogVisible = true;
    },
    handleSelectionChange(rowTable) {
      this.selectRow = [];
      rowTable.forEach((temp) => {
        this.selectRow.push(temp.id);
      });
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata();
    },
    reset() {
      this.formInline = {
        name: "",
        region: this.region,
        report_cycle: this.report_cycle,
        date_range: this.date_range,
        above_scale: "",
      };
      this.getdata();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata();
    },
    toDetail(row) {
      this.editCode = row.code;
      this.zdjcqyczbId = row.id;
      this.report_yidong = row.report_yidong;
      this.showDialogVisible = true;
    },
    exportData() {
      let column = [
        {
          title: "填报单位",
          key: "company_name",
        },
        {
          title: "报表名",
          key: "name",
        },
        {
          title: "填报期",
          key: "date_range",
        },
        {
          title: "填报开始时间",
          key: "date_range",
        },
        {
          title: "填报结束时间",
          key: "date_range_end",
        },
        {
          title: "上报时间",
          key: "crt_time",
        },
      ];
      export2Excel(column, this.tableData, "未审核");
    },
  },
  created() {
    if (this.report_cycle) {
      this.formInline.report_cycle = this.report_cycle;
    }
    if (this.region) {
      this.formInline.region = this.region;
    }
    if (this.date_range) {
      this.formInline.date_range = this.date_range;
    }
    this.getdata();
  },
};
</script>

<style scoped lang="less">
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>